import getConfig from 'config/web'
import LanguageType from 'models/language-type'
import { GlobalState } from 'types'

const { languages } = getConfig()

export const getLanguage = (state: GlobalState): LanguageType => state.language
export const getLanguages = (): string[] => ([...languages])
